const Home = () => (
    <section id="home">
        <h1>Hi!</h1>
    </section>
);

export default Home;
